<template>
    <div class="container">
        <div class="row pt-5">
            <div class="col">
                <div class="row pt-3">
                    <div class="col">
                      <nav>
                        <ol class="breadcrumb">
                          <li class="breadcrumb-item mx-3"><router-link  to="/">الرئيسية</router-link></li>
                          <i class="fa-solid fa-chevron-left pt-1"></i>
                            <router-link to="/paymentcards">
                          <li class="breadcrumb-item active mx-3 almarai-bold black-color" aria-current="page">بطاقاتي</li>
                            </router-link>
                          <i class="fa-solid fa-chevron-left pt-1"></i>
                          <li class="breadcrumb-item active mx-3 almarai-bold black-color" aria-current="page">أضف بطاقة جديدة</li>
                        </ol>
                      </nav>
                    </div>
                </div>
                <div class="row py-3">
                    <div class="col">
                        <div class="almarai-bold font-20">أضف بطاقة جديدة</div>
                    </div>
                </div>
                <errorAlert v-if="hasError" :alertMessage="message" />
                <div class="row py-2">
                    <div class="col-12">
                        <label for="" class="fonttext-14 gray-color">رقم البطاقة *</label>
                        <input type="text" class="form-control input-style" v-model="cardNumber" >
                    </div>
                </div>
                <div class="row py-2">
                    <div class="col">
                        <label for="" class="fonttext-14 gray-color">تاريخ الانتهاء *</label>
                        <input v-mask="'##/####'" class="form-control input-style" maxlength="7" v-model="expirationDate" placeholder="MM/YYYY" />
                    </div>
                </div>
                <div class="row py-5 justify-content-center">
                    <div class="col-8">
                        <div v-if="isLoading" class="text-center"><img src="/assets/images/loader-2.gif" class="w-prcentage-12" alt=""></div>
                        <button v-else @click.prevent="addPayment" class="submit-button almarai-bold form-control">اضافة البطاقة</button>
                    </div>
                </div>
            </div>
        </div>
        <!--begin:modal addpaymentcard-->
        <div class="modal hidden-Fileds bg-color-B" tabindex="-1" id="addCard">
            <div class="modal-dialog width-800">
                <div class="modal-content">
                <div class="modal-body">
                <div class="row justify-content-center pt-3">
                    <div class="col-12 text-center">
                        <img src="/assets/images/tick-circle.png" alt="">
                    </div>
                </div>
                <div class="row pt-3">
                    <div class="col text-center">
                        <p class="font-24 almarai-bold text-center mb-1">تم اضافة بطاقة جديدة</p>
                        <div class="fonttext-14 gray-color almarai-regular">استمتع بالدفع السهل و السريع بسبب ميزة حفظ البطاقات لدينا</div>
                    </div>
                </div>
                <div class="row py-3">
                    <div class="col">
                    <router-link to="/paymentcards">
                        <div class="back almarai-bold text-center">عودة الى بطاقاتي</div>
                    </router-link>
                    </div>
                </div>
                </div>
                </div>
            </div>
        </div>
        <!--end:modaladdpaymentcard--->
    </div>
</template>
<script>
export default {
    name: 'addpaymentcard',
    data(){
        return{
        hasError: false,
        message: "",
        isLoading: false,
        cardNumber: "",
        expirationDate: null,
        year: null,
        month: null,
        }
    },

    methods:{
        addPayment(){
            this.hasError = false;
            this.isLoading = true;
            this.$http.post('/api/payments/addPayment',{
                number: this.cardNumber,
                expiry_month: parseInt(this.expirationDate.split('/')[0]),
                expiry_year: parseInt(this.expirationDate.split('/')[1]),
            }).then(res => {
                // console.log(res);
                document.getElementById('addCard').style.display = 'block';
                this.isLoading = false;
            }).catch(err => {
                // console.log(err);
                this.isLoading = false;
                this.message = this.$globalError(err);
                this.hasError = true;
                window.scroll(0,0);
            });
        },
    },
    created(){
        window.scroll(0,0);
    }
}
</script>